import type { BranchStatus } from '../enums/BranchStatus'
import type { BranchTranslationEntity } from './BranchTranslationEntity'

export class BranchMiniEntity {
  id?: number
  brandId?: number
  brandName?: string | null
  name?: string | null
  locationName?: string | null
  locationAddressDescription?: string | null
  manualStatus?: BranchStatus
  serviceId?: number
  serviceName?: string | null
  createdAt?: string
  disabled?: boolean
  translations?: Array<BranchTranslationEntity> | null
  averageScore?: number
  channelId?: string | null
  channelName?: string | null
  isVIP?: boolean
  hasMyMealSupport?: boolean
  isExternal?: boolean
}
